"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var actions_1 = require("../actions");
exports.preference = function (state, action) {
    if (state === void 0) { state = { compact: false, theme: 'light' }; }
    if (action.type === actions_1.ActionNames.theme.update) {
        if (action.key === 'compact') {
            return __assign({}, state, { compact: action.val });
        }
        if (action.key === 'theme') {
            return __assign({}, state, { theme: action.val });
        }
    }
    return state;
};
//# sourceMappingURL=preference.js.map